import NavBarMenu from './NavBarMenu/Index'
import NavBarSubMenu from './NavBarMenu/NavBarSubMenu'
import NavBarMenuItem from './NavBarMenu/NavBarMenuItem'

import * as sessionUserSelector from 'selectors/sessionUser'
import { useSelector } from 'react-redux'

import {
  RouteAdminAuditHistoryAny, RouteAdminUsers, RouteAdminUserFilters,
  RouteAdminSubscriptionsViews, RouteAdminSubscriptionsTickets, RouteAdminEmailHistory, RouteAdminFeedback, RouteAdminAuditHistory,
  RouteAdminWebhookEvents,
} from 'routes'

import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'

const NavReports = () => {
  const location = useLocation()
  const { t } = useTranslation()

  const ticketProviders = useSelector(sessionUserSelector.ticketProviders)
  const firstTicketProviderId = ticketProviders[0]?.id

  const matchAuditPath = RouteAdminAuditHistoryAny.matchUrlExact(location.pathname)
  const matchEmailAuditPath = RouteAdminEmailHistory.matchUrlExact(location.pathname)
  const matchReportsPath =
    RouteAdminUsers.matchUrlExact(location.pathname) ||
    RouteAdminUserFilters.matchUrlExact(location.pathname) ||
    RouteAdminSubscriptionsViews.matchUrlExact(location.pathname) ||
    RouteAdminSubscriptionsTickets.matchUrlExact(location.pathname) ||
    RouteAdminFeedback.matchUrlExact(location.pathname) ||
      RouteAdminWebhookEvents.matchUrlExact(location.pathname)

  return (
    <NavBarMenu active={matchReportsPath || matchAuditPath || matchEmailAuditPath} title={t('mainHeader.reports')}>
      <NavBarSubMenu selected={matchAuditPath || matchEmailAuditPath} title={t('mainHeader.audit')}>
        <NavBarMenuItem name={t('mainHeader.auditAll')} to={RouteAdminAuditHistory({ type: 'all_partner_actions' })} />
        <NavBarMenuItem name={t('mainHeader.auditUsers')} to={RouteAdminAuditHistory({ type: 'user_actions' })} />
        <NavBarMenuItem name={t('mainHeader.auditIntegration')} to={RouteAdminAuditHistory({ type: 'integration_actions' })} />
        <NavBarMenuItem name={t('mainHeader.auditAdmin')} to={RouteAdminAuditHistory({ type: 'admin_actions' })} />
        <NavBarMenuItem name={t('mainHeader.sentEmails')} to={RouteAdminEmailHistory()} />
      </NavBarSubMenu>

      <NavBarMenuItem name={t('mainHeader.reportsUsers')} to={RouteAdminUsers()} />
      <NavBarMenuItem name={t('mainHeader.reportsUserFilters')} to={RouteAdminUserFilters()} />
      <NavBarMenuItem name={t('mainHeader.reportsSubscriptions')} to={RouteAdminSubscriptionsViews({ ticketProviderId: firstTicketProviderId })} />
      <NavBarMenuItem name={t('mainHeader.reportsFeedback')} to={RouteAdminFeedback()} />

      {Boolean(process.env.ENABLE_TS_WEBHOOKS === 'true') && (
        <NavBarMenuItem name={t('mainHeader.webhookEvents')} to={RouteAdminWebhookEvents()} />
      )}
    </NavBarMenu>
  )
}

export default NavReports
